import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./App";
import { OrientationGuard } from "./components/OrientationGuard";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <OrientationGuard />
    <App />
  </StrictMode>,
);
